import "./EmailButton.css";
import EmailIcon from '@mui/icons-material/Email';
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { SxProps, Theme } from '@mui/material/styles';

interface EmailButtonProps {
    email: string;
    emailFontSize?: string | number;
    emailIconScale?: string | number;
    iconTextGap?: string | number;
    sx?: SxProps<Theme>;
}

const EmailButton: React.FC<EmailButtonProps> = ({
    email,
    emailFontSize = '19px',
    emailIconScale = '2.0',
    iconTextGap = '15px',
    sx,
}) => {
    return (
        <Button
            className='email-button'
            href={`mailto:${email}`}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
                gap: iconTextGap,
                ...sx,
            }}
        >
            <Box className='email-icon'>
                <EmailIcon
                    sx={{
                        transform: `scale(${emailIconScale})`,
                        color: 'var(--color-palette-4)',
                    }}
                />
            </Box>
            <Box
                className='email-text'
                sx={{
                    fontSize: emailFontSize,
                }}
            >
                {email}
            </Box>
        </Button>
    );
};

export default EmailButton;
